<template>
  <div style="line-height: normal;position: relative;">
    <div ref="editor"></div>
    <input type="file" ref="uploadImg" accept="image/png, image/jpeg, image/gif, image/jpg" multiple="multiple"
           @change="uploadImg" style="opacity: 0;position: absolute;">
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],

  [{'header': 1}, {'header': 2}],               // custom button values
  [{'list': 'ordered'}, {'list': 'bullet'}],
  [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
  [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
  [{'direction': 'rtl'}],                         // text direction

  [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
  [{'header': [1, 2, 3, 4, 5, 6, false]}],

  [{'color': []}, {'background': []}],          // dropdown with defaults from theme
  [{'font': []}],
  [{'align': []}],
  ['image'],

  ['clean']
];

export default {
  name: "QuillEditor",
  props: {
    value: '',
  },
  data() {
    return {
      Quill: null,
      images: [],
      html: '',
    }
  },
  watch: {
    value: {
      handler() {
        if (this.html != this.value) {
          const val = this.value == null ? '' : this.value;
          this.html = val;
          if (this.Quill) {
            this.Quill.container.firstChild.innerHTML = val;
            // this.Quill.pasteHtml(val)
          }
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.initEditor();
  },
  beforeDestroy() {
    this.Quill = null
  },
  methods: {
    initEditor() {
      this.Quill = new Quill(this.$refs.editor, {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow'
      });
      // console.log(this.Quill)
      const toolbar = this.Quill.getModule('toolbar');
      toolbar.addHandler('image', () => {
        this.$refs.uploadImg.click();
      })
      document.getElementsByClassName('ql-editor')[0].addEventListener("paste", e => {
        if (!(e.clipboardData && e.clipboardData.items)) {
          return;
        }
        for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
          const item = e.clipboardData.items[i];

          if (item.kind == "string") {
            item.getAsString(function (str) {
              if (str.indexOf('<img') > 0) {
                this.$message.warining('注意！粘贴内容包含图片，网页复制图片APP内无法显示，请手动删除粘贴图片再上传!');
              }
            })
          }
        }
      });
      this.html = this.value == null ? '' : this.value;
      // this.Quill.container.firstChild.innerHTML = this.content;
      // // this.Quill.pasteHtml(this.content)
      // this.$forceUpdate()
      // this.Quill.on("text-change", (delta, oldDelta, source) => {
      //   const html = this.$refs.editor.children[0].innerHTML;
      //   // const text = this.Quill.getText();
      //   // const quill = this.Quill;
      //   this.content = html;
      //   this.$emit("input", html);
      //   // this.$emit("change", {html, text, quill});
      //   this.$emit("change", html);
      //   console.log(html)
      // });
      this.Quill.on("text-change", (delta, oldDelta, source) => {
        const html = this.$refs.editor.children[0].innerHTML;
        const text = this.Quill.getText();
        const length = this.Quill.getLength();
        const quill = this.Quill;
        // console.log('text', text, length)
        // console.log('html', html)
        // console.log('quill', quill)
        this.html = html;
        this.$emit("input", html);
        // this.$emit("change", {html, text, quill});
        this.$emit("change", {html, text});
        // this.$emit("change", html);
        this.$emit("on-text-change", delta, oldDelta, source);
      });
      this.Quill.on("selection-change", (range, oldRange, source) => {
        this.$emit("on-selection-change", range, oldRange, source);
      });
      this.Quill.on("editor-change", (eventName, ...args) => {
        this.$emit("on-editor-change", eventName, ...args);
      });
    },
    uploadImg(e) {
      const xhr = new XMLHttpRequest();
      const files = e.target.files;
      const formData = new FormData();
      formData.append("file", files[0]);
      xhr.onreadystatechange = (e) => {
        if (xhr.readyState == 4) {
          const data = JSON.parse(xhr.responseText);
          // console.log(data);
          const url = data.url;
          if (url) {
            this.images.push(url);
            this.Quill.insertEmbed(this.Quill.getSelection().index, 'image', url);
          }

        }
      }
      xhr.open('POST', this.$apiUrl.imgUpload, true);
      xhr.send(formData);
    },
  }
}
</script>

<style scoped lang="scss">
.ql-container {
  height: 400px !important;
}
</style>


// WEBPACK FOOTER //
// QuillEditor.vue?43629e34